<template>
    <Toast />
    <h1>{{$t("assistance.sectionName")}}</h1>
    <div class="grid">
        <div class="sm:col-12 md:col-4 lg:col-4" >
            <div class="assistence-box">
                <h6>{{$t("assistance.callUs")}}</h6>
                <p>{{$t("assistance.callUsBody")}}</p>
                <div class="hyperlink">
                    <Button icon="pi pi-phone" class="p-button-text p-button-plain" :label="callUsLabel"/>
                </div>
            </div>
        </div>
        <div class="sm:col-12 md:col-4 lg:col-4 assistance-box">
            <div class="assistence-box">
                <h6>{{$t("assistance.liveChat")}}</h6>
                <p>{{$t("assistance.liveChatBody")}}</p>
                <div class="hyperlink">
                    <Button icon="pi pi-comments" class="p-button-text p-button-plain" :label="chatWithUsLabel"/>
                </div>
            </div>
        </div>
        <div class="sm:col-12 md:col-4 lg:col-4 assistance-box">
            <div class="assistence-box">
                <h6>{{$t("assistance.goToTicket")}}</h6>
                <p>{{$t("assistance.goToTicketBody")}}</p>
                <div class="hyperlink">
                    <Button icon="pi pi-question-circle" class="p-button-text p-button-plain" :label="checkYourTicketsLabel" @click="goToYourTickets()"/>
                </div>
            </div>
        </div>
    </div>

    <div class="grid">
        <div class="sm:col-12 md:col-4 lg:col-4">
            <h4> {{$t("assistance.service")}}</h4>
                <div class="grid">
                    <div class="col-6">
                        <Card>
                            <template #content>
                                {{$t("assistance.instructions")}}
                            </template>
                        </Card>
                    </div>
                    <div class="col-6">
                        <Card>
                            <template #content>
                                {{$t("assistance.warranty")}}
                            </template>
                        </Card>
                    </div>
                    <div class="col-6">
                        <Card>
                            <template #content>
                               {{$t("assistance.registerProduct")}}
                            </template>
                        </Card>
                    </div>
                    <div class="col-6">
                        <Card>
                            <template #content>
                                {{$t("assistance.accessoriesReplacements")}}
                            </template>
                        </Card>
                    </div>
                    <div class="col-6">
                        <Card>
                            <template #content>
                                {{$t("assistance.checkCare")}}
                            </template>
                        </Card>
                    </div>
                    <div class="col-6">
                        <Card>
                            <template #content>
                                {{$t("assistance.news")}}
                            </template>
                        </Card>
                    </div>
                </div>
        </div>
        <div class="sm:col-12 md:col-8 lg:col-8">
            <h4> {{$t("assistance.requestAssistance")}}</h4> 
            <div class="grid">
                <div class="col-6">
                    <InputText id="name" :placeholder="placeholderName" v-model="name"/>
                </div>
                <div class="col-6">
                    <InputText id="surname" :placeholder="placeholderSurname" v-model="surname"/>
                </div>
                <div class="col-6">
                    <InputText id="email" :placeholder="placeholderEmail" v-model="email"/>
                </div>
                <div class="col-6">
                    <InputText id="telephone" :placeholder="placeholderTel" v-model="telephone"/>
                </div>

                <div class="col">
                    <Dropdown v-model="selectedOption" :options="options" optionLabel="name" :placeholder="placeholderDropdown" />
                </div>

                <div class = "col-12">
                    <h6>{{$t("assistance.notes")}}</h6>
                    <textarea class="custom-text-area" v-model="ticketContent" style="width:100%" rows="5"></textarea>
                </div>
                <div class = "col-12">
                    <Button style="float:right" :label="placeholderSubmit" @click="sendTicket()"/>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import TicketService from "../service/TicketService";

export default {
    data(){
        return {
            callUsLabel: this.$t('assistance.number'),
            chatWithUsLabel: this.$t("assistance.chatWithUsButtonLabel"),
            checkYourTicketsLabel: this.$t("assistance.checkYourTicketsLabel"),
            placeholderName: this.$t("assistance.placeholderName"),
            placeholderSurname: this.$t("assistance.placeholderSurname"),
            placeholderEmail: this.$t("assistance.placeholderEmail"),
            placeholderTel: this.$t("assistance.placeholderTel"),
            placeholderDropdown: this.$t("assistance.placeholderDropdown"),
            placeholderSubmit: this.$t("assistance.placeholderSubmit"),
            newTicketSuccessMessage: this.$t("assistance.newTicketSuccessMessage"),
            newTicketSuccessDetail: this.$t("assistance.newTicketSuccessDetail"),
            newTicketFailMessage: this.$t("assistance.newTicketFailMessage"),
            newTicketFailDetail: this.$t("assistance.newTicketFailDetail"),

            telephone:null,
            selectedOption:null,
            ticketContent:null,
            options:[
                {name:"Test Product"},
                {name:"Test Appliance"},
                {name:"Test Recipes"}
            ]

        }
    },
    computed: {
        access_token: function() {
            return this.$store.getters["userdata/getAccessToken"];
        },
        name: function() {
            return this.$store.getters["profile/name"];
        },
        email: function(){
            return this.$store.getters["profile/email"];
        },
        surname: function() {
            return this.$store.getters["profile/surname"];
        }
    },
    created() {
        this.ticketService = new TicketService();
    },
    methods: {
       async sendTicket(){
        let responseCode = await this.ticketService.postNewTicket(this.access_token, this.selectedOption.name, this.ticketContent);
        if (responseCode == 200){
            this.$toast.add({severity:'success', summary: this.newTicketSuccessMessage, detail: this.newTicketSuccessDetail, life: 3000});
        } else {
            this.$toast.add({severity:'error', summary: this.newTicketFailMessage, detail:this.newTicketFailDetail, life: 3000});
        }
        this.resetFields();
       },
       resetFields(){
        this.selectedOption = null;
        this.ticketContent = null
       },
       goToYourTickets(){
            this.$router.push({ name: "tickets"});
        },
    }

}

    
</script>

<style scoped>

    .grid {
        display: flex;
        flex-wrap: wrap;
        margin-right: -0.5rem;
        margin-left: -0.5rem;
        margin-top: -0.5rem;
        margin-bottom: 10px;
    }

    .col{
        flex-grow: 1;
        flex-basis: 0;
        padding: 1rem; 
        
    }

    .col-4{
        height: inherit;
        flex: 0 0 auto;
        padding: 1rem;
        width: 33.3333%;
    }

    .col-6{
        height: inherit;
        flex: 0 0 auto;
        padding: 1rem;
        width: 50%;
    }

    .col-8 {
        height: inherit;
        flex: 0 0 auto;
        padding: 1rem;
        width: 66.6667%;
    }
    .col-12{
        height: inherit;
        flex: 0 0 auto;
        padding: 1rem;
        width: 100%;
    }

    .assistence-box {
        background: #F0F2F4;
        border-radius: 10px;
        padding:20px;
    }

    h4 {
        font-weight: 600;
    }
    h6{
        font-weight: 600;
        font-size: 20px;
    }

    p{
        font-weight: 400;
    }
    
    .hyperlink{
        text-align: center;
    }

    .p-inputtext{
        width: 100%;
        border-radius: 18px;
        border-width: 1px;
        border-color: #272728;
        padding-left: 10px;
    }
    .p-dropdown{
        width: 100%;
        border-radius: 10px;
        background-color: #FAFAFA;
        border-color: #FAFAFA;
    }
    
    .p-card{
        text-align: center;
        height: 120px;
    }
    
    .custom-text-area{
        width: 100%;
        border-radius: 10px;
        border-color: #FAFAFA;
        background-color: #FAFAFA;
        padding: 10px;
        resize: none;
    }

    .custom-text-area:focus{
        border-color: #FAFAFA;
    }
    
    input:focus {
        border-width: 0px;
    }

    .p-button.p-button-text.p-button-plain {
        color: #00434C;
        font-weight: 600;
    }

    .p-button:focus{
        outline: 0 none;
        outline-offset: 0;
        box-shadow: #00434C;
    }
</style>